import * as React from 'react';

interface IStickyHeaderProps extends React.PropsWithChildren {
	pageYOffset: number;
	onStuckChange: (stuck: boolean) => any;
}

interface IStickyHeaderState {
	stuck: boolean;
}

export class StickyHeader extends React.Component<IStickyHeaderProps, IStickyHeaderState> {

	constructor(props: IStickyHeaderProps) {
		super(props);
		this.state = { stuck: false };
		this.handleScroll = this.handleScroll.bind(this);
	}

	public componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	public componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	public handleScroll() {
		let nextStuck;
		if (window.pageYOffset >= this.props.pageYOffset) {
			nextStuck = true;
		} else {
			nextStuck = false;
		}

		if (this.state.stuck !== nextStuck) {
			this.setState({ stuck: nextStuck });
			this.props.onStuckChange(nextStuck);
		}
	}

	public render() {
		const { children } = this.props || {} as IStickyHeaderProps;
		return <div className={'sticky-head__container'}>
			{children}
		</div>;
	}
}
